import type {
  ConsultationListResponse,
  ConsultationDetail,
  ConsultationTab,
  SaveNotesPayload,
  PublishResponse,
} from "../types/consultation";
import { apiFetch } from "./client";

const BASE = "/api/v1/doctor/consultations";

export async function listConsultations(
  tab: ConsultationTab = "upcoming",
  page = 1,
  perPage = 10,
): Promise<ConsultationListResponse> {
  const params = new URLSearchParams({
    tab,
    page: String(page),
    per_page: String(perPage),
  });
  return apiFetch<ConsultationListResponse>(`${BASE}?${params}`);
}

export async function getConsultation(id: string): Promise<ConsultationDetail> {
  return apiFetch<ConsultationDetail>(`${BASE}/${id}`);
}

export async function saveNotes(id: string, payload: SaveNotesPayload): Promise<ConsultationDetail> {
  return apiFetch<ConsultationDetail>(`${BASE}/${id}/notes`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export async function publishConsultation(id: string, attestationChecked: boolean): Promise<PublishResponse> {
  return apiFetch<PublishResponse>(`${BASE}/${id}/publish`, {
    method: "POST",
    body: JSON.stringify({ attestation_checked: attestationChecked }),
  });
}
